<!-- 日次締め -> 売掛金 -> レジ締め済取引の払戻・修正 / 過去営業日取引の追加 Get new set of data and display only, will not update by others -->
<template>
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table past-business-day-transactions-table"
    stripe
    border
  >
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.accountsReceivableType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </div>
        <div v-else>{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>

    <el-table-column
      prop="qty"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.qty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.qty | separatorFormatter((isInitData && !isEmptyData) && actionType !== 'detail') }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualQty"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.actualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== 'detail') }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.cashQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== 'detail') }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.dayActualQty')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.dayActualQty | separatorFormatter((isInitData && !isEmptyData) && actionType !== 'detail') }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="amount"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.amount')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.amount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualAmount"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.actualAmount')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualAmount | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.cashBalance')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashBalance | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.accountsReceivableTable.pastBusinessDayTransactionsTable.th.actualSales')"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualSales | currencyFormatter((isInitData && !isEmptyData) && actionType !== "detail") }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "PastBizDayTrans",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    isInitData: {
      type: Boolean,
      default: true,
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      const _tableData = tranfResData(this.tableData);
      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          // let __price = this.receivableListMappingFn(type, _item.settlementId).price || 0;
          // __price = __price !== 0 ? __price : rounding(_item.amount / _item.qty);
          // _item.price = __price;
          _item.type = type;
          _item.index = i;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
    isEmptyData() {
      const _tableData = tranfResData(this.tableData);
      const {
        couponType,
        nationalTicket,
        settlement,
      } = _tableData;

      if (couponType.length === 0 && nationalTicket.length === 0 && settlement.length === 0) {
        return true;
      }

      return false;
    },
  },
  methods: {
    // massageData() {
    //   //massage this.rawData to tableData
    //   const allData = this.rawData;
    //   let finalArray = [];

    //   //total for whole table
    //   const total = {
    //     qty : 0 ,
    //     actualQty: 0,
    //     cashQty : 0,
    //     dayActualQty: 0,
    //     amount: 0,
    //     actualAmount: 0,
    //     cashBalance: 0,
    //     actualSales: 0
    //   };

    //   Object.keys(allData).map(key => {

    //     //each type
    //     let subTotalPerType = {
    //       qty : 0 ,
    //       actualQty: 0,
    //       cashQty : "-",
    //       dayActualQty: 0,
    //       amount: 0,
    //       actualAmount: 0,
    //       cashBalance: "-",
    //       actualSales: 0
    //     };

    //     allData[key].map((typeTotal, idx) => {
    //       //get type obj from key
    //       const typeKeyName = key.replace("Total", ""); //settlement / nationalTicket / couponType
    //       const typeObj = this.getAccountsReceivableTypeObj(typeKeyName);

    //       const newObj = {};
    //       newObj["rowType"] = "normal"; //normal / empty-row / subtotal / total
    //       newObj["arType"] = typeObj[0].key;//for grouping decision : settlement / nationalTicket / couponType
    //       newObj["accountsReceivableType"] = typeObj[0].label; //for table display
    //       newObj["accountReceivableName"] = typeTotal.name;

    //       newObj["qty"] = typeTotal.qty;
    //       newObj["actualQty"] = typeTotal.actualQty;
    //       newObj["cashQty"] = "-"; //always hard code

    //       newObj["dayActualQty"] = typeTotal.dayActualQty;

    //       newObj["amount"] = typeTotal.amount;
    //       newObj["actualAmount"] = typeTotal.actualAmount;
    //       newObj["cashBalance"] = "-"; //always hard code
    //       newObj["actualSales"] = typeTotal.actualSales;
    //       finalArray.push({ ...newObj });


    //       //calculate subTotalPerType
    //       subTotalPerType.qty += typeTotal.qty;
    //       subTotalPerType.actualQty += typeTotal.actualQty;
    //       // subTotalPerType.cashQty += typeTotal.cashQty;
    //       subTotalPerType.dayActualQty += typeTotal.dayActualQty;
    //       subTotalPerType.amount += typeTotal.amount;
    //       subTotalPerType.actualAmount += typeTotal.actualAmount;
    //       // subTotalPerType.cashBalance += typeTotal.cashBalance;
    //       subTotalPerType.actualSales += typeTotal.actualSales;

    //       //last row per type
    //       if(idx === allData[key].length - 1) {
    //         const lastRowSubTotal = {
    //           rowType: "subtotal",
    //           accountReceivableName: typeObj[0].label + " 合計",

    //           qty: subTotalPerType.qty,
    //           actualQty: subTotalPerType.actualQty,
    //           // cashQty :  subTotalPerType.cashQty,
    //           cashQty :  "-",
    //           dayActualQty : subTotalPerType.dayActualQty,
    //           amount: subTotalPerType.amount,
    //           actualAmount:  subTotalPerType.actualAmount,
    //           // cashBalance: subTotalPerType.cashBalance,
    //           cashBalance: "-",
    //           actualSales : subTotalPerType.actualSales
    //         };

    //         finalArray.push({ ...newObj, ...lastRowSubTotal });
    //       }

    //     });
    //     //calculate total
    //     total.qty += subTotalPerType.qty;
    //     total.actualQty += subTotalPerType.actualQty;
    //     // total.cashQty += subTotalPerType.cashQty;
    //     total.dayActualQty += subTotalPerType.dayActualQty;
    //     total.amount += subTotalPerType.amount;
    //     total.actualAmount += subTotalPerType.actualAmount;
    //     // total.cashBalance += subTotalPerType.cashBalance;
    //     total.actualSales += subTotalPerType.actualSales;
    //   });

    //   //add all types summary
    //   const lastRowTotal = {
    //     rowType : "total",
    //     accountReceivableName: "合計",
    //     qty: total.qty,
    //     actualQty: total.actualQty,
    //     // cashQty :  total.cashQty,
    //     cashQty : "-",
    //     dayActualQty: total.dayActualQty,
    //     amount: total.amount,
    //     actualAmount:  total.actualAmount,
    //     // cashBalance: total.cashBalance,
    //     cashBalance: "-",
    //     actualSales: total.actualSales
    //   };

    //   finalArray.push({ ...lastRowTotal });

    //   this.tableData = formatPastBusinessDayTransactionsTableData(finalArray);
    //   this.rowSpanGrouping(this.rowSpanArr1, this.rowSpanPosition1, "accountsReceivableType", this.tableData);
    // },
    // rowSpanGrouping(spanArr, position, spanName, tableData) {
    //   tableData.forEach((item, index) => {
    //     if (index === 0) {
    //       spanArr.push(1);
    //       position = 0;
    //     } else if (
    //       tableData[index][spanName] === tableData[index - 1][spanName]
    //     ) {
    //       spanArr[position] += 1;
    //       spanArr.push(0);
    //     } else {
    //       spanArr.push(1);
    //       position = index;
    //     }
    //   });
    // },
    spanMethod({ row, columnIndex }) {
      if (row.rowType === "total") {
        if (columnIndex === 0) {
          return [1, 2];

        } else if (columnIndex < 2) {
          return [0, 0];
        }
      }

      if (columnIndex === 0) {
        const { rowspan, colspan } = row;
        return [rowspan, colspan];
      }
    },
    rowClassName({ row }) {
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      }
      return "";
    },
  },
};

</script>